import { getBasicContentSchema } from '@/lib/zy-tiptap-utils';
import { Node, ReactNodeViewRenderer, mergeAttributes } from '@tiptap/react';
import ZyDefnBlockNodeView from './zydefn-block-node-view';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        zydefnBlock: {
            setZyDefnBlock: () => ReturnType;
            toggleZyDefnBlock: () => ReturnType;
            unsetZyDefnBlock: () => ReturnType;
        };
    }
}

export const ZyDefnBlockHeadless = Node.create({
    name: 'zydefnBlock',

    group: 'block',

    content() {
        return getBasicContentSchema();
    },

    addAttributes() {
        return {
            terms: {
                default: '',
                parseHTML: element => {
                    const termSpans = element.querySelectorAll('span.term[data-term="true"]');
                    return Array.from(termSpans).map(span => span.textContent || '') || [];
                },
                renderHTML: attributes => {
                    const terms = attributes.terms;
                    if (!terms || (Array.isArray(terms) && terms.length === 0)) {
                        return {};
                    }
                    return { 'data-terms': JSON.stringify(Array.isArray(terms) ? terms : [terms]) };
                },
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'span[data-definition="true"][data-definition-mode="block"]',
                getAttrs: element => {
                    if (
                        !(element instanceof HTMLElement) ||
                        element.getAttribute('data-definition') !== 'true' ||
                        element.getAttribute('data-definition-mode') !== 'block'
                    ) {
                        return false;
                    }
                    return {};
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['zyDefnBlock', mergeAttributes(HTMLAttributes), 0];
    },

    addCommands() {
        return {
            setZyDefnBlock:
                () =>
                ({ commands }) => {
                    return commands.wrapIn(this.name);
                },
            toggleZyDefnBlock:
                () =>
                ({ commands }) => {
                    return commands.toggleWrap(this.name);
                },
            unsetZyDefnBlock:
                () =>
                ({ commands }) => {
                    return commands.lift(this.name);
                },
        };
    },
});

export const ZyDefnBlock = ZyDefnBlockHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyDefnBlockNodeView);
    },
});

export default ZyDefnBlock;
